import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import EstacionamientoService from "../services/EstacionamientoService";
import { useNavigate, NavLink } from "react-router-dom";

function RefreshClock(){

  const [date, setDate] = useState(new Date());
  const iniDate =  new Date(date);
  
  
    const differenceInSeconds = (a, b) => 
    { return Math.floor((a.getTime() - b.getTime())/ (1000 * 60) );
    }
    
  
    function refreshClock() {
      window.location.reload();
  }
  useEffect(() => {
    const timerId = setInterval(refreshClock, 1000 * 60 * 10);
    return function cleanup() {
      clearInterval(timerId);
    };
  }, []);
  return (
   <></>
  );
}
export default RefreshClock;